import { connect } from 'react-redux'
import WorklistAttachment from './WorklistAttachment'
import * as selector from "../state/selector";
import * as action from "../state/action";
import {push} from "connected-react-router";
import {selectUserId} from "../../security/state/auth/selector";

const mapStateToProps = (state, props) => {
    return {
        taskListWithAttachment: selector.selectTaskListWithAttachment(state),
        tableSetting: selector.selectTableSetting(state),
        currentUserId: selectUserId(state),
    }
}

const mapDispatchToProps = {
    findTaskListWithAttachment: action.findTaskWithAttachmentList,
    changeTableSetting: action.changeTableSetting,
    initialColumnsVisibility: action.initialColumnsVisibility,
    navigateToTaskDetail: (taskId) => {
        return push('/task/detail/' + taskId)
    },
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WorklistAttachment)



// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/component/WorklistAttachmentContainer.js